module.exports = __webpack_public_path__ + "img/Interior-Design-logo-design-Tashii-Designs.22bf4efd.jpg";